import { IconProps, IconSize, MaterialColors } from "@/core/types/types";
import DynamicMaterialIcons from "../MaterialIcons/MaterialIcons";
import GenericSVG from "@/core/components/GenericSVG/CustomSVG";
import getIconPathIfExists from "@/core/utils/getFilePathIfExists";
import { useState, useEffect } from "react";

const LocalIcon = ({
  iconName,
  iconColor,
  iconSrc,
  canBeFilled,
}: {
  iconName: string | undefined;
  iconColor?: string | MaterialColors;
  iconSrc?: string;
  canBeFilled?: boolean;
}) => {
  const [iconSrcState, setIconSrcState] = useState<string | null>(null);
  useEffect(() => {
    const loadIcon = async () => {
      if (iconName && !iconSrc) {
        const lowerCaseIconName = iconName.toLowerCase();
        const svgFilePath = `images/icons/${lowerCaseIconName}.svg`;
        const gifFilePath = `images/icons/${lowerCaseIconName}.gif`;

        const svgExists: string | null = await getIconPathIfExists(svgFilePath);
        if (svgExists) {
          setIconSrcState(svgFilePath);
        } else {
          const gifExists: string | null = await getIconPathIfExists(
            gifFilePath
          );
          return gifExists
            ? setIconSrcState(gifFilePath)
            : setIconSrcState(null);
        }
      }
      if (iconSrc) {
        setIconSrcState(iconSrc);
      }
    };
    loadIcon();
  }, [iconName]);

  if (!iconSrcState) return null;
  return (
    <GenericSVG
      path={iconSrcState}
      color={iconColor}
      canBeFilled={canBeFilled}
    />
  );
};

export const IconComponent = ({
  iconName,
  iconColor,
  iconCustomColor,
  iconSize = IconSize.Medium,
  iconSrc,
  canBeFilled,
}: IconProps) => {
  const MaterialIcon = iconName && DynamicMaterialIcons[iconName];
  if (!iconSrc && MaterialIcon) {
    return (
      <MaterialIcon
        color={iconColor}
        sx={{
          color: iconCustomColor,
          width: `${iconSize}px !important`,
          height: `${iconSize}px !important`,
        }}
      />
    );
  } else {
    return (
      <LocalIcon
        iconSrc={iconSrc}
        iconName={iconName}
        iconColor={iconColor}
        canBeFilled={canBeFilled}
      />
    );
  }
};
